import { createSsrRequestContext, type SsrRequestContext } from '@repo/ssr'
import { createMiddleware, createStart } from '@tanstack/react-start'

declare module '@tanstack/react-router' {
	interface Register {
		server: {
			requestContext: SsrRequestContext
		}
	}
}

const ssrRequestContextMiddleware = createMiddleware().server(
	async ({ request, next }) =>
		next({ context: createSsrRequestContext(request) })
)

export const startInstance = createStart(() => ({
	defaultSsr: import.meta.env.MODE === 'ssr-all',
	requestMiddleware: [ssrRequestContextMiddleware]
}))
